import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import { routerMiddleware, routerReducer } from 'react-router-redux';
import createSagaMiddleware from 'redux-saga';
import reducers from '../reducers';
import sagas from '../sagas';

export default (history) => {
  const sagaMiddleware = createSagaMiddleware();
  const composeEnhancers = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  const store = createStore(
    combineReducers({
      ...reducers,
      routing: routerReducer,
    }),
    composeEnhancers(applyMiddleware(
      sagaMiddleware,
      routerMiddleware(history),
    ))
  );

  // NOTE: Temporarily disable due to Gatsby build error. For more info - https://github.com/gatsbyjs/gatsby/issues/3972
  sagaMiddleware.run(sagas);

  return store;
};



// WEBPACK FOOTER //
// ./src/store/index.js